'use strict';
import angular from 'angular'

function FloatingBoxController($rootScope, $scope, $timeout, $location, objectMakerFactory, dataHolderFactory, printerService, localStorageService, appSettings, dataRequestService, usSpinnerService, constantSettings) {
  
  const self = this;
  this.initFilter = function() {
    const searchObject = $location.search();
    if (searchObject.contrato) {
      $timeout(function() {
        $scope.$emit('openViewWithContext', 'CONTRACTS');
      }, 1000);
    }
  };

  $rootScope.$on('openViewWithContext', function(event, context) {
    $scope.openViewForContext(context);
  });

  $rootScope.$on('restoreFloatingBox', function() {
    $rootScope.restoreViewControl();
  });

  $rootScope.$on('mapaCarregado', function() {
    self.initFilter();
  });

  $rootScope.$on('didOpenGallery', function() {
    $scope.floatingBoxViewControl.makeFloatingOpaque = true;
  });

  $rootScope.$on('showingOnMap', function() {
    $scope.floatingBoxViewControl.activeButtonsControl = false;
  });

  $rootScope.$on('didCloseGallery', function() {
    $scope.floatingBoxViewControl.makeFloatingOpaque = false;
  });

  $rootScope.$on('updatedFavoriteFilterSelected', function(context, favoriteFilterSelected) {
    $scope.floatingBoxViewControl.hasFavoriteFilterSelected = !!favoriteFilterSelected;
  });

  $scope.initFloatingBoxController = function() {
    const originalFilters = localStorageService.get('originalFilters');
    dataHolderFactory.updateFilterOptions(originalFilters);
    $scope.floatingBoxViewControl = objectMakerFactory.viewObjectControlForFloatingBox();
    $scope.floatingBoxViewControl.hasDocuments = appSettings.config.filter.documentos;
    $scope.floatingBoxViewControl.showFavoriteFilters = appSettings.config.show.favoriteFilters;
    $scope.floatingBoxViewControl.showVideo = appSettings.config.show.showVideo;
  };

  $scope.showLegendBox = function() {
    $rootScope.appControl.showLegendBox = true;
    $scope.$emit('closeInfoView');
  };

  $scope.showAboutBox = function() {
    $rootScope.appControl.showAboutBox = true;
    $scope.$emit('closeInfoView');
  };

  $scope.showVideoBox = function() {
    $rootScope.appControl.showVideoBox = true;
    $scope.$emit('closeInfoView');
  };

  $scope.openViewForContext = function(context) {
    $scope.$emit('closeInfoView');

    if ($scope.appControl.contextType) {
      $scope.floatingBoxViewControl.activeButtonsControl = false;
      $scope.floatingBoxViewControl.showContractsInfo = false;
    }

    $rootScope.appControl.showDetailsBox = false;
    $rootScope.appControl.showFilterBox = true;
    $rootScope.appControl.showSearchBar = false;
    $rootScope.appControl.showAboutBox = false;
    $rootScope.appControl.showLegendBox = false;
    $rootScope.appControl.showVideoBox = false;
    $scope.floatingBoxViewControl.showContractsInfo = false;
    $scope.floatingBoxViewControl.activeButtonsControl = true;
    $scope.appControl.animaTodasObra = true;
    if ($scope.appControl.contextType == '') {
      $rootScope.appControl.showFloatingControl = false;
    }
    if (context === 'HOME') {
      $rootScope.restoreViewControl();
      $rootScope.$emit('centerMapOnMe');
    } else {
      $scope.appControl.contextType = context;
    }
  };

  const keepMapPropertiesToRestore = function() {
    const keepMapProperties = {};
    if ($rootScope.appControl) {
      keepMapProperties.showingInMap = $rootScope.appControl.showingInMap;
    }
    return keepMapProperties;
  };

  const restorePropertiesMap = function(keepMapProperties) {
    for (let propertyName in keepMapProperties) {
      $rootScope.appControl[propertyName] = keepMapProperties[propertyName];
    }
  };

  $rootScope.restoreViewControl = function() {
    const logo = angular.copy($rootScope.appControl.logoUrl);
    const keepMapProperties = keepMapPropertiesToRestore();
    $rootScope.appControl = objectMakerFactory.viewObjectControlForApp();
    restorePropertiesMap(keepMapProperties);
    $rootScope.appControl.logoUrl = logo;
    dataHolderFactory.updateClusteredContracts([]);
    $rootScope.appControl.currentContract = '';
    $scope.appControl.contextType = '';
    $scope.floatingBoxViewControl.activeButtonsControl = false;
    $scope.floatingBoxViewControl.showContractsInfo = false;
    $rootScope.$emit('cleanMarkersOpacity');
    $rootScope.$emit('clearPolygons');
    $timeout(function() {
      $rootScope.$broadcast('initSearchController');
    }, 1000);
  };

  $scope.sendEmail = function() {
    $scope.floatingBoxViewControl.showContractsInfo = false;
    if ($rootScope.appControl.showEmailBox) {
      return;
    }
    dataHolderFactory.updatePdfDataUri(printerService.pdfPrintingForContractList(true, dataHolderFactory.getContracts()));
    $rootScope.appControl.showEmailBox = true;
  };

  $scope.printPDF = function() {
    $scope.$emit('setGoogleAnalyticsData',constantSettings.actionReportSimplified);
    printerService.pdfPrintingForContractList(false, dataHolderFactory.getContracts());
  };

  $scope.printPDFDetalhado = async function(isEmail) { 
    $scope.$emit('setGoogleAnalyticsData',constantSettings.actionReportDetailed);
    usSpinnerService.spin('spinner-1');    
    $scope.disabledBtPdfDetalhado = true;
    
    await printerService.pdfPrintingForAllContractDetails(false, dataHolderFactory.getContracts());
    
    usSpinnerService.stop('spinner-1'); 

    $timeout(function() {      
      $scope.disabledBtPdfDetalhado = false;
    }, 50);   
  };

  $scope.printODTDetalhado = async function() { 
    $scope.$emit('setGoogleAnalyticsData',constantSettings.actionReportEditable);
    usSpinnerService.spin('spinner-1');    
    $scope.disabledBtOdtDetalhado = true;

    const filterOptions = dataHolderFactory.getSavedFilterOptions();   
 
    dataRequestService.getContractsReportData(objectMakerFactory.viewObjectExtractionForFilter(filterOptions))
    .then(function(response) {

        usSpinnerService.stop('spinner-1');

        if (!response.data) {
          console.error('No file data received');
          return;
        }
    
        var contentType = response.headers('Content-Type') || 'application/octet-stream';
        var blob = new Blob([response.data], { type: contentType });
        var url = window.URL.createObjectURL(blob);
      
        var a = document.createElement('a');
        a.href = url;
        a.download = 'relatorio.odt';
        document.body.appendChild(a);
        a.click();

        $scope.disabledBtOdtDetalhado = false;

      }, function(error) {
        console.error('Download failed:', error);
      });
  };
}

FloatingBoxController.$inject = ['$rootScope', '$scope', '$timeout', '$location', 'objectMakerFactory', 'dataHolderFactory', 'printerService', 'localStorageService', 'appSettings', 'dataRequestService', 'usSpinnerService', 'constantSettings'];
export default FloatingBoxController



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/floatingBoxController.js